import * as React from "react";
import MapViewSwitchButton from "../MapViewSwitchButton";

interface ISatelliteButtonProps {
  satelliteLayerIsOn: boolean;
  onClick: () => any;
}

const SatelliteButton = ({
  satelliteLayerIsOn,
  onClick,
}: ISatelliteButtonProps) => (
  <MapViewSwitchButton
    className="satellite-switch-button"
    onClick={onClick}
    imgSrc={
      satelliteLayerIsOn ? "baselayer-map.png" : "baselayer-satellite.png"
    }
  />
);

export default SatelliteButton;
